const couponStatus = {
  0: "gift_card_on_hold",
  1: "gift_card_used",
  2: "gift_card_canceled"
};

export default couponStatus;
